import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { advertisementTableColumnsConfig } from "./advertisementTableColumnDef";
import { Table } from "../../../component/table/Table";
import { useSelector } from "react-redux";
import { selectAdvertisementState } from "../../../store/advertisementFilterSlice";
import {
  selectAdvertisementList,
  useGetAdvertisementListQuery,
} from "../../../services/advertisement/advertisementApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const AdvertisementTablePage = () => {
  const [columnDefs, setColumnDefs] = useState([]);
  const navigate = useNavigate();

  const appliedFilters = useSelector(selectAdvertisementState);

  const { isSuccess, isLoading, isFetching } =
    useGetAdvertisementListQuery(appliedFilters);
  const tableData = useSelector(selectAdvertisementList);

  const handleNavigateToDetail = useCallback(
    (rowData) => {
      navigate(`${rowData.id}`);
    },

    [navigate],
  );

  useEffect(() => {
    setColumnDefs(
      advertisementTableColumnsConfig["advertisement"](handleNavigateToDetail),
    );
  }, [handleNavigateToDetail]);

  return isSuccess ? (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading || isFetching}
    />
  ) : (
    <CategoryPageSkeleton />
  );
};
